import { css, styled } from 'styled-components';
import { SkapaColors, SkapaText, SkapaTokens } from '@inter-ikea-guida/skapa';
const BUTTON_BORDER_RADIUS = '16px';
const SELECTION_BORDER_WIDTH = '3px';
const SELECTION_BORDER_COLOR = SkapaColors.colourNeutral7;
export const StyledContainer = styled.div `
  display: flex;
  flex-direction: column;

  border: none;
  background-color: transparent;
  padding: 0;

  cursor: ${props => (props.$disabled ? 'unset' : 'pointer')};
  pointer-events: ${props => (props.$disabled ? 'none' : 'unset')};
`;
export const StyledFlexColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledContainerButton = styled.button `
  display: flex;
  flex-direction: column;

  border-radius: ${SkapaTokens.radiusM};

  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;

  * {
    cursor: pointer;
  }
`;
const getFilledButtonBackgroundColor = (hexColor, selected, hover, selectedColorOverride) => {
    if (selected || hover) {
        if (selectedColorOverride) {
            return selectedColorOverride;
        }
        if (hover) {
            // Alpha channel for 50% opacity
            const BUTTON_ALPHA_HEX = '80';
            // Lighten the color by adding/modifying alpha channel
            const lightenedColor = hexColor.substring(0, 7) + BUTTON_ALPHA_HEX;
            return lightenedColor;
        }
    }
    return hexColor;
};
const getDashedButtonCss = (hover) => {
    const FILL = hover ? '#FFDB00' : 'none';
    const STROKE_COLOR = '#929292';
    const STROKE_WIDTH = 2;
    const dashedSVGStroke = `%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg' %3e%3crect width='100%25' height='100%25' fill='${encodeURIComponent(FILL)}' rx='${BUTTON_BORDER_RADIUS}' ry='${BUTTON_BORDER_RADIUS}' stroke='${encodeURIComponent(STROKE_COLOR)}' stroke-width='${STROKE_WIDTH}' stroke-dasharray='10%2c 10' stroke-dashoffset='0' stroke-linecap='round' /%3e%3c/svg%3e`;
    // Ignore needed for not formatting double qoutes in url
    // prettier-ignore
    return css `
    background-image: url("data:image/svg+xml,${dashedSVGStroke}");

    border-radius: ${BUTTON_BORDER_RADIUS};
    background-clip: padding-box;
  `;
};
export const StyledContentWrapper = styled.div `
  aspect-ratio: ${props => props.$aspectRatio};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${props => props.$justifyContent ?? 'center'};

  border: ${props => (props.$isSelected && props.$style === 'filled' ? 'solid' : 'none')};
  border-radius: ${BUTTON_BORDER_RADIUS};
  border-width: ${SELECTION_BORDER_WIDTH};
  border-color: ${SELECTION_BORDER_COLOR};

  transition: all ${SkapaTokens.durationStandardWeb};

  svg,
  img {
    color: ${SkapaColors.colourStaticBlack};
  }

  svg {
    height: 3rem;
    width: 3rem;
  }

  img {
    height: 4rem;
    width: 4rem;
  }

  ${props => props.$style === 'dashed' && getDashedButtonCss(props.$isHovering)}

  background-color: ${props => props.$style === 'filled' &&
    getFilledButtonBackgroundColor(props.$color, props.$isSelected, props.$isHovering, props.$selectedColor)};
`;
export const StyledLabel = styled.label `
  margin-top: ${SkapaTokens.space50};
  cursor: pointer;
`;
export const StyledLabelText = styled(SkapaText) `
  margin: 0;
  text-align: start;

  font-weight: ${props => props.$subtle ? SkapaTokens.fontWeightRegular : SkapaTokens.fontWeightBold};
`;
export const StyledCheckmarkContainer = styled.div `
  position: absolute;
  inset-inline-end: ${SkapaTokens.space50};
  top: ${SkapaTokens.space50};
`;
export const StyledInnerContentWrapper = styled.div `
  position: relative;
  width: 100%;
  cursor: pointer;
`;
// The reason for this wrapper is that if the border is applied directly to the image element,
// the border will be affected by the opacity changes which we do not want.
export const StyledImageWrapper = styled.div `
  border: ${({ $isSelected }) => ($isSelected ? 'solid' : 'none')};
  border-radius: ${SkapaTokens.radiusL};
  border-width: ${SELECTION_BORDER_WIDTH};
  border-color: ${SELECTION_BORDER_COLOR};
`;
export const StyledImage = styled.img `
  aspect-ratio: ${props => props.$aspectRatio};
  width: 100%;
  display: ${props => (props.$imageLoaded ? 'block' : 'none')};

  border-radius: ${SkapaTokens.radiusM};

  object-fit: cover;
  opacity: ${props => (props.$isHovering ? 0.5 : 1)};

  transition: all ${SkapaTokens.durationStandardWeb};

  pointer-events: ${props => (props.$isKiosk ? 'none' : 'unset')};
`;
export const StyledSkeletonWrapper = styled.div `
  position: relative;
  aspect-ratio: ${props => props.$aspectRatio};
  width: 100%;

  div:first-child {
    border-radius: ${SkapaTokens.radiusS};
  }
`;
//# sourceMappingURL=styles.js.map